<div
  mat-dialog-title
  class="modal-title"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <span class="modal-title-label">{{ httpService.getTransation().ReaderSettings }}</span>
  <button
    class="modal-close-button"
    mat-icon-button
    [matTooltip]="httpService.getTransation().Close"
    (click)="onCancel()"
    tabindex="-1"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="reader-settings-modal-content">
  <div class="reader-settings-field">
    <label class="reader-settings-label">
      {{ httpService.getTransation().ReaderLanguage }}
    </label>
    <mat-form-field appearance="outline" class="reader-settings-language">
      <mat-select [(value)]="selectedLanguageCode">
        <mat-select-trigger>
          <span class="reader-language-option" *ngIf="getSelectedLanguageOption()">
            <span class="reader-language-flag">{{ getSelectedLanguageOption()?.flag }}</span>
            <span class="reader-language-text">{{ getSelectedLanguageOption()?.label }}</span>
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let option of data.languageOptions" [value]="option.value">
          <span class="reader-language-option">
            <span class="reader-language-flag">{{ option.flag }}</span>
            <span class="reader-language-text">{{ option.label }}</span>
          </span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="reader-settings-field">
    <label class="reader-settings-label">
      {{ httpService.getTransation().ReaderWaitPerBead }}
    </label>
    <div class="reader-settings-hint">
      Delay after each spoken segment.<br>
      Total wait = bead count x selected value.
    </div>
    <div class="reader-settings-wait">
      <mat-slider
        class="reader-settings-slider"
        [min]="data.timeOptions[0]"
        [max]="data.timeOptions[data.timeOptions.length - 1]"
        [step]="waitPerBeadStepMs"
        [value]="selectedWaitPerBeadMs"
        [thumbLabel]="true"
        [displayWith]="getTimeOptionLabel.bind(this)"
        (change)="onWaitPerBeadChange($event.value)"
      >
      </mat-slider>
      <span class="reader-settings-wait-value">{{ getTimeOptionLabel(selectedWaitPerBeadMs) }}</span>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end" class="reader-settings-actions">
  <button mat-stroked-button cdkFocusInitial (click)="onCancel()">
    {{ httpService.getTransation().Cancel }}
  </button>
  <button mat-raised-button color="primary" (click)="onSave()">
    {{ httpService.getTransation().Ok }}
  </button>
</div>
